import { useAtomValue } from "jotai";
import { scannerRequestStateAtom, advancedSettingsAtom } from "../../../../components/Atoms/atoms";
import { listOfAnswerOptions, listOfKeys } from "../../utils/common";
import RangeSlider from "./RangeSlider";
import { Divider, Tooltip } from "@mui/material";

export default function AdvancedQuestionInputs(props) {
	const { handleMCExamChange } = props;
	const state = useAtomValue(scannerRequestStateAtom);
	const advancedSettings = useAtomValue(advancedSettingsAtom);
	return (
		<div className="flex flex-col gap-4">
			<div className="flex flex-col w-full">
				<label htmlFor="hqNum" className="font-medium text-primary pb-2">
					Select Start and End Question Numbers
					<span className="text-xs text-gray-500 pl-2 ">
						(If non-contiguous, you can specify which questions to omit in the per-item
						configuration below.)
					</span>
				</label>
				<RangeSlider />
			</div>
			<Divider />

			<div className="flex flex-col">
				<label htmlFor="qLen" className="font-medium text-primary">
					How many answer options for each question?
					<span className="text-sm text-gray-500">
						(If varied, select the highest - A,B,C,D,E = 5)
					</span>
				</label>
				<div className="flex flex-col sm:flex-row gap-2 mb-2 mt-1">
					{listOfAnswerOptions.map((option) => (
						<button
							key={option.label}
							className={`flex items-center gap-2 p-2 border rounded mb-1 ${
								state.qLen === option.value
									? "bg-primary text-white"
									: "bg-white border-gray-300 hover:bg-gray-50 text-gray-500"
							}`}
							onClick={() =>
								handleMCExamChange({
									target: { name: "qLen", value: option.value },
								})
							}
						>
							{option.label}
						</button>
					))}
				</div>
			</div>
			<Divider />
			<div className="flex flex-col pb-4">
				<label htmlFor="nKeys" className="font-medium text-primary">
					How many versions/answer keys have you created for your exam?
				</label>

				<div className="flex flex-col sm:flex-row gap-2 mb-2 mt-1">
					{listOfKeys.map((option) => (
						<Tooltip
							key={option.label}
							title={
								advancedSettings.mrscor && Number(option.value) > 1
									? "MRSCOR only supports 1 exam version per job. Please separate student sheets into versions and submit as multiple requests if you have more than 1 version."
									: ""
							}
							placement="top"
						>
							<span>
								<button
									disabled={
										(advancedSettings.formulaScoring && Number(option.value) > 4) ||
										(advancedSettings.compositeScoring && Number(option.value) > 5) ||
										(advancedSettings.mrscor && Number(option.value) > 1)
									}
									className={`flex items-center gap-2 p-2 border rounded mb-1 disabled:bg-gray-300 disabled:cursor-not-allowed ${
										state.nKeys === option.value
											? "bg-primary text-white"
											: "bg-white border-gray-300 hover:bg-gray-50 text-gray-500"
									}`}
									onClick={() =>
										handleMCExamChange({
											target: { name: "nKeys", value: option.value },
										})
									}
								>
									{option.label}
								</button>
							</span>
						</Tooltip>
					))}
				</div>
			</div>
		</div>
	);
}
